import { useTranslation } from "react-i18next";
import { useOrgFeatures } from "../../../../permissions";
import { DataAccessRow } from "./DataAccessRow";
import { DATA_ACCESS_FEATURES, isFeatureAllowedForPlan } from "./roleEditorConfig";
import { RoleEditor } from "./useEditRoleDialog";

export interface DataAccessTableProps {
  editor: RoleEditor;
}

export const DataAccessTable = ({ editor }: DataAccessTableProps) => {
  const { t } = useTranslation("settings");
  const { plan } = useOrgFeatures();
  const visibleFeatures = DATA_ACCESS_FEATURES.filter((feature) => isFeatureAllowedForPlan(plan, feature.key));

  return (
    <div className="w-full min-w-0 overflow-x-auto rounded-md border">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b bg-muted/50 text-left text-xs font-medium text-muted-foreground">
            <th className="py-2 pl-4 pr-4">{t("Feature")}</th>
            <th className="py-2 px-2 text-center">{t("Show in Sidebar")}</th>
            <th className="py-2 px-2">{t("Create")}</th>
            <th className="py-2 px-2">{t("Read")}</th>
            <th className="py-2 px-2">{t("Update")}</th>
            <th className="py-2 px-2">{t("Delete")}</th>
          </tr>
        </thead>
        <tbody>
          {visibleFeatures.map((feature) => (
            <DataAccessRow key={feature.key} feature={feature} editor={editor} plan={plan} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
